<template>
  <div id="slider-uniform">
      <hooper ref="carousel" style="height: 260px" :class="error ? 'error' : ''" :itemsToShow="1" :centerMode="true" pagination="yes" :infiniteScroll="true" @slide="getUniform">
          <slide v-for="uniform in uniforms" :value="uniform.id" :key="uniform.id">
            <Equipment
              :equipment="uniform"
              :error="error"
              :is_preview="is_preview"
              :sport="sport"
            >
            </Equipment>
          </slide>
          <hooper-pagination slot="hooper-addons"></hooper-pagination>
          <hooper-navigation slot="hooper-addons"></hooper-navigation>
        </hooper>
      
        <!-- <div class="actions" @click="editUniform()">
            {{$t('edit')}}
        </div> -->

  </div>
</template>

<script>

import Equipment from '@/components/ui/Equipment.vue';
import { 
    Hooper, 
    Slide, 
    Pagination as HooperPagination, 
    Navigation as HooperNavigation  
} from 'hooper';
import 'hooper/dist/hooper.css';

export default {
    name: 'SliderUniform',
    components: {
        Equipment,
        Hooper,
        Slide,
        HooperPagination,
        HooperNavigation
    },
    props: {
        uniforms: {},
        error: false,
        is_preview: false,
        sport: {},
        mode: 0,
        assigned_uniform: {}
    },
    data(){
        return {
            selected: ''
        }
    },
    computed: {
        aUniforms: function(){
            return ObjectToArray(this.uniforms);
        }
    },
    created(){},
    mounted(){
        // check if is assigned an uniform to scroll
        if(Object.keys(this.assigned_uniform).length > 0){
            // index to scroll
            let index = 0;
            let aUniforms = ObjectToArray(this.uniforms);
            for(let i in aUniforms){
                //  compare assigned uniform and uniform from the list
                if(aUniforms[i].id == this.assigned_uniform.id){
                    // save index
                    index = i;
                }
            }
            // scroll into index
            this.$refs.carousel.slideTo(index);
        }
        
    },
    methods: {
        getUniform(payload){
            
            // get current Slide
            let indexSlide = payload.currentSlide;
            
            // validate infinite scroll to left
            if(indexSlide == -1) {
                indexSlide = Object.keys(this.uniforms).length;
                indexSlide--;
            }

            // validate ininite scroll to right
            if(indexSlide == Object.keys(this.uniforms).length){
                indexSlide = 0;
            }
            
            // get uniform
            let uniform_selected = Object.keys(this.uniforms)[indexSlide];

            // validate if uniform is not undefined
            if(typeof uniform_selected !== 'undefined'){
                
                // assign uniform
                this.selected = uniform_selected;
                
                // emmit new uniform to parent component
                this.$emit('selected',this.selected,this.mode);

            }

        },
        editUniform(){
            this.$emit('edit',this.selected,this.mode);
        }
    }

}
</script>
<style lang="scss" scoped>
    #slider-uniform {
        
        .hooper-slide {
            background-color: rgb(238, 238, 238);
        }

        .actions {
            width: 50%;
            display: block;
            padding: 6px;
            border-radius: 0 0 3px 3px;
            background-color: transparent;
            cursor: pointer;
            text-align: center;
            margin: 0 auto;
            margin-top: 10px;
            font-size: 17px;
            font-weight: bold;
            font-family: AvantGarde-Bold;
            text-transform: uppercase;
            transition: background-color 0.5s ease;
            border: 1px solid #fc8926;

            &:hover {
               background-color: #fc8a2623 !important;
            }
        }

        .error {
          border: 2px solid $alert-color;
        }
    }
</style>
